<script>
import CardTag from '@/views/Scenario/StepEditor/Card/CardTag.vue'

export default {
    name: 'CardTag',
    extends: CardTag,
    computed: {
        tagList () {
            return this.card.config.detail.map(o => {
                return {
                    name: o.tag_name,
                    code: o.tag_code
                }
            })
        }
    }
}
</script>
